function ToggleSwitch({
  handleClick,
  show = true,
  value,
  id,
  disabled,
  name,
  checked,
  title = "",
  ariaLabel = "",
  required = false,
  errorMessage,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof title === "string" && title.trim() ? title.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Toggle switch";

  if (!show) {
    return null;
  }

  return (
    <div title={title}>
      <label className="form-switch p-0">
        <input
          type="checkbox"
          onChange={handleClick}
          className={"form-check-input" + (!disabled ? "cursor-pointer" : "")}
          value={value}
          id={id}
          disabled={disabled}
          name={name}
          checked={checked}
          title={title}
          aria-label={ariaLabelText}
          aria-required={isRequired}
        />
        <span
          className={"form-slider round" + (disabled ? " disabled" : "")}
        ></span>
      </label>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
}

export default ToggleSwitch;
